module.exports = __webpack_public_path__ + "app/community/list-cooperatives-community-2hoiFpU0.html";